import { DownOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Dropdown, Menu, Popconfirm } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { MosaicComponent, getPointPermission, statusOptions } from '@/components'
import { PAGE_RESOURCE_POINTS_ENUM, ProjectStatus as PS, Project, ResourceUser } from '@/schemas'

// import { ProjectDetailModal } from '../project-detail-modal.component'

interface ProjectStatusProps {
  project: Project
  users?: ResourceUser[]
  onChange: () => void
}

export const ProjectStatus: React.FC<ProjectStatusProps> = ({ project, onChange }) => {
  const { t } = useTranslation()
  const { canUpdate, canRead } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_状态, project.permissions)
  const [dropdownVisible, setDropdownVisible] = React.useState<boolean | undefined>(undefined)

  const { run, loading } = useRequest(
    (status) => ({
      url: '/api/project/updateProject',
      method: 'patch',
      data: {
        selfId: project.selfId,
        status,
      },
    }),
    {
      manual: true,
      onSuccess: async () => {
        onChange()
        setDropdownVisible(undefined)
      },
      onError() {
        setDropdownVisible(undefined)
      },
    }
  )

  const options = statusOptions.filter(({ value }) => ![PS.已结项].includes(value))

  if (!canRead) {
    return <MosaicComponent />
  }

  const menu = (
    <Menu>
      {options.map((o) => {
        return (
          <Menu.Item
            onClick={async () => {
              await run(Number(o.value))
            }}
            key={o.value}
          >
            {t(o.label)}
          </Menu.Item>
        )
      })}
      <Popconfirm
        title={
          <div className='text-red-500'>
            <div>{t('project.status.close.tooltip')}</div>
          </div>
        }
        onVisibleChange={(visible) => {
          if (!visible && !loading) {
            setDropdownVisible(undefined)
          }
        }}
        onCancel={() => setDropdownVisible(undefined)}
        onConfirm={() => run(PS.已结项)}
        cancelText={t('cancel')}
        okText={t('customer.flowStatus.ProjectWaitForFinish.popover.button')}
        okButtonProps={{ loading }}
        cancelButtonProps={{ disabled: loading }}
      >
        <Menu.Item onClick={() => setDropdownVisible(true)} key={PS.已结项}>
          {project.status === PS.已结项 ? t('已结项') : t('结项')}
        </Menu.Item>
      </Popconfirm>
    </Menu>
  )

  return (
    <>
      {project.status === PS.已结项 ? (
        <span className='cursor-not-allowed text-gray-300'>{t(PS[project.status])}</span>
      ) : (
        <Dropdown {...(dropdownVisible && { visible: true })} disabled={!canUpdate} overlay={menu} trigger={['click']}>
          <span className='cursor-pointer'>
            {t(PS[project.status!])} <DownOutlined className='ml-1' />
          </span>
        </Dropdown>
      )}
    </>
  )
}
